/** @jsxImportSource @emotion/react */
import { Icon } from "@coreai/component-library";
import { css, useTheme } from "@emotion/react";
import React, { useEffect } from "react";
import { useLanguage } from "LanguageContext";
import { updateUserConsent } from "services/userServices";

interface InlineInformationProps {
  setDisplayInline: (disp: boolean) => void;
  showAnalysisResultConsent: boolean | null;
}
export default function InlineInformation(
  props: Readonly<InlineInformationProps>
) {
  const { t } = useLanguage();
  const theme = useTheme();
  if (props?.showAnalysisResultConsent === false) {
    return null;
  }

  const containerStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: ${theme.colors.feedbackBackground};
  border: 1.2px solid ${theme.colors.primary};
  border-radius: 12px;
  padding: 16px 12px;
  color: #1a3e64;
  margin-top: ${theme.spacing["5xl"]};
`;

const contentStyle = css`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
`;

const iconStyle = css`
  margin: 0 12px;
  color: ${theme.colors.primary};
`;

const textStyle = css`
  font-family: ${theme.typography.subbody_medium.fontFamily};
  font-size: ${theme.typography.subbody_medium.fontSize};
  font-weight: ${theme.typography.subbody_medium.fontWeight};
  flex: 1;
`;

const buttonStyle = css`
  background-color: ${theme.colors.primary};
  color: white;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 20px;
  padding: 4px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  align-self: flex-end;
  margin-right: 12px;
  &:hover {
    background-color: ${theme.colors.primary};
  }
`;

  return (
    <div css={containerStyle}>
      <div css={contentStyle}>
        <Icon css={iconStyle} name="announcement"></Icon>
        <div css={textStyle}>{t("analyse_result_inlineInformation_text")}</div>
      </div>
      <button css={buttonStyle} onClick={() => {
        updateUserConsent().then((result: any) => {
          if (result?.success) {
            props.setDisplayInline(false)
          }
        }).catch((error: any) => {
          console.log({error},'updateUserConsent')
        })
      }}>
        {t("analyse_result_inlineInformation_button")}
      </button>
    </div>
  );
}
